import React, { useEffect, useMemo, useState } from "react";

import GameRounds, { Props as GameRoundsProps } from "../GameRounds";

const query = `
{
  boterhamshowPrijzenkastCollection {
    items {
      woord,
      woordenCollection {
        items {
          woord,
          afbeelding {
            url,
            title
          },
          audio {
            url
          }
        }
      },
      antwoord {
        woord
      },
      startAudio {
        url
      },
      succesAudio {
        url
      }
    }
  }
}
`;

type Item = {
  readonly woord: string;
  readonly afbeelding: {
    readonly url: string;
    readonly title: string;
  };
  readonly audio: null | { readonly url: string };
};

type Data = {
  readonly boterhamshowPrijzenkastCollection: {
    readonly items: ReadonlyArray<{
      readonly woord: string;
      readonly woordenCollection: {
        readonly items: readonly [Item, Item, Item];
      };
      readonly antwoord: {
        readonly woord: string;
      };
      readonly startAudio: {
        readonly url: string;
      };
      readonly succesAudio: {
        readonly url: string;
      };
    }>;
  };
};

export type GameContainerProps = {
  readonly isMuted?: boolean;
  readonly bgMusicRef?: React.RefObject<HTMLAudioElement>;
};

type Response = {
  readonly data: Data;
  readonly errors: unknown;
};

// eslint-disable-next-line @typescript-eslint/prefer-readonly-parameter-types
const GameContainer = ({
  isMuted = false,
  bgMusicRef,
}: GameContainerProps): React.ReactElement | null => {
  const [data, setData] = useState<null | Data>(null);

  useEffect(() => {
    void window
      .fetch(`https://graphql.contentful.com/content/v1/spaces/t22qbzbg0h3n/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer hB7xO81jOlPGssTxq3rMAaLnll4iFGKM-5h1ROwg9UM",
        },
        body: JSON.stringify({ query }),
      })
      // eslint-disable-next-line @typescript-eslint/prefer-readonly-parameter-types
      .then((response) => response.json())
      .then(({ data, errors }: Response) => {
        if (errors) {
          console.error(errors);
          return;
        }

        setData(data);
      });
  }, []);

  const rounds: null | GameRoundsProps["gameRounds"] = useMemo(() => {
    if (!data) return [];

    return data.boterhamshowPrijzenkastCollection.items.map(
      ({ woord, woordenCollection, antwoord, startAudio, succesAudio }) => ({
        word: woord,
        words: woordenCollection.items.map(
          ({ woord, afbeelding: { url, title }, audio }) => ({
            imageUri: url,
            altText: title,
            isCorrect: woord === antwoord.woord,
            audioUri: audio?.url,
          })
        ),
        introAudioUri: startAudio.url,
        successAudioUri: succesAudio.url,
      })
    );
  }, [data]);

  if (!rounds || rounds.length <= 0) return null;

  return (
    <GameRounds gameRounds={rounds} isMuted={isMuted} bgMusicRef={bgMusicRef} />
  );
};

export default GameContainer;
